<template>
	<el-container>
		<!--顶栏容器-->
		<el-header height="50px">
			<Header :moduleList="topTabList" @itemClick='itemClick' :tabIndex="selectIndex"/>
		</el-header>
		<el-container>
			<!--侧边栏容器-->
			<el-aside width="66px">
				<!-- <Left :asideList="asideList" /> -->
				<Left :asideList="topTabList" />
			</el-aside>
			<el-container>
				<!--路由标签-->
				<el-header height="48px">
					<RouterTags/>
				</el-header>
				<!--主要区域容器-->
				<el-main>
					<keep-alive>
						<router-view :key="key" />
					</keep-alive>
				</el-main>
			</el-container>
		</el-container>
	</el-container>
</template>
<script>
	import Header from "../components/Header/Header.vue"
	import Left from "../components/Left/Left.vue"
	import RouterTags from "../components/RouterTags/RouterTags.vue"
	import dataList from "../util/module.js"
    import {
        adminMenu
	} from "../request/apis.js"
	import {
		mapActions
	} from 'vuex';
	export default {
		components: {
			Header,
			Left,
			RouterTags
		},
		data() {
			return {
				topTabList: [],
				asideList: [],
				selectIndex: 0
			}
		},
		computed: {
			key() {
				return this.$route.path
			}
		},
		mounted() {
            this.getMenu();
            this.topTabList = [];
			this.asideList = [];
		},
		methods: {
			...mapActions(['setBusinessInfo']),
			...mapActions(['setMenuInfo']),
            ...mapActions(['setPermitArr']),
			
            async getMenu(){
                const res = await adminMenu();
                if(res.code){
                    return this.$message.error(res.msg);
                }
                this.$bus.$emit('changeCrmModel', res.data.info.crm_model);
                localStorage.setItem('crmModel', res.data.info.crm_model)
				this.setBusinessInfo(res.data.info);
				this.setMenuInfo(res.data.menuInfo);
                this.setPermitArr(res.data.nodes);
                res.data.menuInfo.forEach((item,index) => {
                    item.name = item.title;
                    item.path = item.href;
					item.checked = index==0?true:false;
					if(item.child && item.child.length){
						item.child.forEach(item2 => {
						    item2.name = item2.title;
						    item2.path = item2.href;
						    item2.child.length && item2.child.forEach(item3 => {
						        item3.name = item3.title;
						        item3.path = item3.href;
						    })
						})
					}
                });
				// res.data.menuInfo[3].child.push({
				// 	href: "",
				// 	icon: "el-icon-house",
				// 	name: "报表",
				// 	path: "",
				// 	rule_id: 2100,
				// 	rule_pid: 2009,
				// 	target: "_self",
				// 	title: "报表",
				// 	child : [{
				// 		href: "/shopSurvey",
				// 		icon: "el-icon-house",
				// 		name: "经营概况",
				// 		path: "/shopSurvey",
				// 		rule_id: 2103,
				// 		rule_pid: 2100,
				// 		target: "_self",
				// 		title: "经营概况"
				// 	},{
				// 		href: "/shopStatistics",
				// 		icon: "el-icon-house",
				// 		name: "商城订单",
				// 		path: "/shopStatistics",
				// 		rule_id: 2102,
				// 		rule_pid: 2100,
				// 		target: "_self",
				// 		title: "商城订单"
				// 	},{
				// 		href: "/shopBill",
				// 		icon: "el-icon-house",
				// 		name: "账户流水",
				// 		path: "/shopBill",
				// 		rule_id: 2101,
				// 		rule_pid: 2100,
				// 		target: "_self",
				// 		title: "账户流水"
				// 	}]
				// })
                this.topTabList = res.data.menuInfo;
			    this.asideList = res.data.menuInfo[this.selectIndex] ? res.data.menuInfo[this.selectIndex].child : [];
            },

			//tab切换回调
			itemClick(index) {
				this.selectIndex = parseInt(index);
				this.asideList = this.topTabList[index] ? (this.topTabList[index].child||[]) : []
			}
		}
	}
</script>
<style scoped>
	.el-header {
		padding: 0;
	}

	.el-container {
		height: 100%;
	}

	.el-main {
		padding: 10px 10px;
		background: #f5f5f5;
		height: 70px;
		min-width: 500px;
		/* margin-bottom: 66px; */
	}
</style>